import type { ECommerceOfferWithNames } from "../../eCommerce/eCommerceTypes";
import type { ListPublicPackagesResponseItem } from "../../publicPackages/publicPackagesApi";

export function getOffersForPackages(
  packages: ListPublicPackagesResponseItem[],
  offers: ECommerceOfferWithNames[],
): Record<string, ECommerceOfferWithNames[]> {
  const childrenByParentId = packages.reduce<Record<string, ListPublicPackagesResponseItem[]>>((acc, pkg) => {
    if (!pkg.parentPackageId) {
      return acc;
    }

    (acc[pkg.parentPackageId] ??= []).push(pkg);

    return acc;
  }, {});

  const offersByPackageId = offers.reduce<Record<string, ECommerceOfferWithNames[]>>((acc, offer) => {
    if (offer.packageId) {
      (acc[offer.packageId] ??= []).push(offer);
    }

    return acc;
  }, {});

  const getPackageIds = (packageId: string): string[] => {
    const children = childrenByParentId[packageId] ?? [];

    return [packageId, ...children.flatMap((child) => getPackageIds(child.id.id))];
  };

  return packages.reduce<Record<string, ECommerceOfferWithNames[]>>((acc, pkg) => {
    const packageIds = getPackageIds(pkg.id.id);

    acc[pkg.id.id] = packageIds.flatMap((id) => offersByPackageId[id] ?? []);

    return acc;
  }, {});
}
